<template>
  <div class="meterial-input-page" >
    <a-row :gutter="13">
      <a-col :xl="leftColWidth"  :span="24"  >
        <group-list @chooseDepart="handleChooseDepart"></group-list>
      </a-col>
      <a-col :xl="rightColWidth" :span="24" v-show="choosedWorkshopId"  >
        <groupmember-list   ref="refworkshop" @close="handleCloseWorkshop" ></groupmember-list>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import GroupList from '@/views/gisFactoryInspection/components/GroupList.vue'
import GroupmemberList from '@/views/gisFactoryInspection/components/GroupmemberList.vue'

export default {
  data() {
    return {
      choosedWorkshopId:""
    }
  },
  components:{
    GroupList,GroupmemberList
  },
  methods: {
    handleChooseDepart(record){
      this.choosedWorkshopId=record.id
      let recordCopy=JSON.parse(JSON.stringify(record))
      recordCopy.departId=recordCopy.id;
      delete recordCopy.id;
      this.$nextTick(()=>{
        this.$refs.refworkshop.choosedDepart(this.choosedWorkshopId);
      })
      console.log(this.choosedWorkshopId)
    },
    handleCloseWorkshop(){
      this.choosedWorkshopId=''
    }
  },
  computed:{
    leftColWidth(){
      return this.choosedWorkshopId?10:24
    },
    rightColWidth(){
      return this.choosedWorkshopId?14:0
    }
  },
}
</script>

<style lang="less" scoped>
.meterial-input-page{
  height: 100%;
}
</style>